import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  adDetails: {
    marginTop: 16,
    paddingLeft: 8,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    columnGap: 12
  },
  adDetailsLeftColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: '95%',
    overflow: 'hidden',
    rowGap: 8
  },
  adName: {
    fontSize: 14,
    lineHeight: '17px',
    fontWeight: 400,
    wordBreak: 'break-word'
  },
  internalAdActionButtons: {
    marginTop: 20
  },
  skeletonAdCardListItem: {
    height: '100%'
  }
})

export default useStyles
